import api from 'api'
import {
  CACHE_TAG_DETECTION_DETAILS,
  CACHE_TAG_EXCEPTION_VERSION_LIST,
  CACHE_TAG_WORK_ORDER_DETAILS,
  CACHE_TAG_WORK_ORDER_STATUS_HISTORY,
} from 'api/cacheTagTypes'

import type {
  AddExceptionMediaApi,
  CreateWorkOrderExceptionApi,
  DeleteWorkOrderExceptionApi,
  UpdateWorkOrderExceptionApi,
} from 'types/api/work-order/workOrderException'

// DTO shapes + BE contract notes live in types/api/work-order/workOrderException.
const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    createWorkOrderException: builder.mutation<unknown, CreateWorkOrderExceptionApi>({
      query: body => ({
        url: `api/v1/exceptions`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [CACHE_TAG_EXCEPTION_VERSION_LIST, CACHE_TAG_WORK_ORDER_DETAILS, CACHE_TAG_WORK_ORDER_STATUS_HISTORY],
    }),
    updateWorkOrderException: builder.mutation<unknown, UpdateWorkOrderExceptionApi>({
      query: ({ id, ...body }) => ({
        url: `api/v1/exceptions/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [CACHE_TAG_EXCEPTION_VERSION_LIST, CACHE_TAG_WORK_ORDER_DETAILS, CACHE_TAG_WORK_ORDER_STATUS_HISTORY],
    }),
    // Attach client-uploaded media refs — the bytes are already in the private uploads
    // bucket (see utils/exceptionMediaUpload); this only registers the references.
    addExceptionMedia: builder.mutation<unknown, AddExceptionMediaApi>({
      query: ({ id, media }) => ({
        url: `api/v1/exceptions/${id}/media`,
        method: 'POST',
        body: { media },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        CACHE_TAG_EXCEPTION_VERSION_LIST,
        CACHE_TAG_WORK_ORDER_DETAILS,
        { type: CACHE_TAG_DETECTION_DETAILS, id },
      ],
    }),
    // Never route this back through the legacy core endpoint — it wiped media but swallowed the row-delete failure.
    deleteWorkOrderException: builder.mutation<unknown, DeleteWorkOrderExceptionApi>({
      query: ({ id }) => ({
        url: `api/v1/exceptions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CACHE_TAG_EXCEPTION_VERSION_LIST, CACHE_TAG_WORK_ORDER_DETAILS, CACHE_TAG_WORK_ORDER_STATUS_HISTORY],
    }),
  }),
})

export const {
  useCreateWorkOrderExceptionMutation,
  useUpdateWorkOrderExceptionMutation,
  useAddExceptionMediaMutation,
  useDeleteWorkOrderExceptionMutation,
} = extendedApi
